import { menuSections } from "../menu-data.js";
import { isLegacyPicPath, shouldPersistImage } from "./images.js";
import { createEmptyMenuItem } from "./menu-fields.js";
import { createEmptyBranch } from "./branch-fields.js";
import {
  defaultGallery,
  defaultHeroSlides,
  defaultStoryParagraphs,
  createEmptyGalleryItem,
  createEmptyHeroSlide,
  createEmptyStoryParagraph,
} from "./home-data.js";
import { authenticate, endSession, readSession } from "./auth.js";
import { fetchRemoteCms, pushRemoteCms, hasRemoteCmsContent } from "./server.js";

const CMS_KEY = "burgermunch-cms";
const AUTH_KEY = "burgermunch-cms-auth";

const defaultBranches = {
  shomron: {
    title: "סניף קרני שומרון",
    branch: "קרני שומרון",
    address: "מתחם תחנת דלק דור אלון, קרני שומרון",
    time: "א' – ה' | 22:45 – 12:00",
    waze: "https://ul.waze.com/ul?place=ChIJ2SFrr7QjHRURM7HJUuMnBuI&ll=32.17507710%2C35.09289750&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location",
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3377.081325894499!2d35.09508082067761!3d32.17508162183217!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151d23b4af6b21d9%3A0xe20627e352c9b133!2z15HXldeo15LXqCDXmNeZ15nXnSDXp9eo16DXmSDXqdeV157XqNeV158!5e0!3m2!1siw!2sil!4v1661950762454!5m2!1siw!2sil",
    image: "../pic/karniSOM.jpg",
  },
  telmon: {
    title: "סניף טלמון",
    branch: "טלמון",
    address: "הערמון 2002, טלמון",
    time: "א' – ה' | 22:45 – 12:00 | מוצאי שבת: שעה מצאת השבת עד 00:00",
    waze: "https://ul.waze.com/ul?preview_venue_id=23003455.230231162.582198&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location",
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2013.2238933861474!2d35.13442045326765!3d31.938494384521324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151d2b20969593ed%3A0xc76e8937071f855!2zQnVyZ2VyTXVuY2gg15HXldeo15LXqCDXnteQ16DXpSAtINeh16DXmdejINeY15zXnteV158gLSDXm9ep16g!5e0!3m2!1siw!2sil!4v1661950425157!5m2!1siw!2sil",
    image: "../pic/talmon2.jpg",
  },
  beitel: {
    title: "סניף בית אל",
    branch: "בית אל",
    address: "תורה ועבודה 4, בית אל",
    time: "א' – ה' | 22:45 – 12:00",
    waze: "https://ul.waze.com/ul?place=ChIJ0zw5jo_VHBURFmWbYcoQTtM&ll=31.94227640%2C35.22400750&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location",
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4026.2742401791957!2d35.228116340431974!3d31.942455716962634!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151cd58f8e393cd3%3A0xd34e10ca619b6516!2z16rXldeo15Qg15XXoteR15XXk9eUIDQsIEJlaXQgRWw!5e0!3m2!1siw!2sil!4v1661950560686!5m2!1siw!2sil",
    image: "../pic/orders1.jpeg",
  },
  tapuach: {
    title: "סניף תפוח",
    branch: "תפוח",
    address: "צומת תפוח, תפוח",
    time: "א' – ה' | 00:00 – 12:00 | מוצאי שבת: שעה מצאת השבת עד 00:00",
    waze: "https://ul.waze.com/ul?preview_venue_id=23134529.231083148.491557&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location",
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2009.314763966906!2d35.257929913578685!3d32.11651858346549!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151d2542c2cee53d%3A0x1c337d634854acee!2zQnVyZ2VyVGltZSDXkdeV16jXkteoINeY15nXmdedLSDXodeg15nXoyDXqtek15XXlyAtINeb16nXqA!5e0!3m2!1siw!2sil!4v1661950658784!5m2!1siw!2sil",
    image: "../pic/tapuach.jpg",
  },
  ariel: {
    title: "סניף אריאל",
    branch: "אריאל",
    address: "מרכז מסחרי רובע א', אריאל",
    time: "א' – ה' | 22:45 – 12:00",
    waze: "https://ul.waze.com/ul?preview_venue_id=23068993.230493323.582618&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location",
    map: "https://www.google.com/maps/embed?pb=!1m21!1m12!1m3!1d211.22861423252317!2d35.17283954076784!3d32.10553229326257!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m6!3e6!4m0!4m3!3m2!1d32.1055275!2d35.1727091!5e0!3m2!1siw!2sil!4v1661950286223!5m2!1siw!2sil",
    image: "../pic/ariel.jpg",
  },
  yakir: {
    title: "סניף יקיר",
    branch: "יקיר",
    address: "שדרות הראשונים, יקיר",
    time: "א' – ה' | 22:45 – 12:00",
    waze: "https://ul.waze.com/ul?preview_venue_id=23003457.230165647.334414&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location",
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3378.028124841077!2d35.11747118547082!3d32.14953962302175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151d24175681ee0d%3A0xf08d2fbf5d8772dc!2z16nXk9eo15XXqiDXlNeo15DXqdeV16DXmdedLCDXmden15nXqA!5e0!3m2!1siw!2sil!4v1660665446094!5m2!1siw!2sil",
    image: "../pic/yakir.jpg",
  },
};

export function sanitizeCmsStorage() {
  const cms = loadCms();
  let changed = false;
  const defaults = defaultBranches;

  if (cms.branches) {
    for (const [id, branch] of Object.entries({ ...cms.branches })) {
      if (branch.image && !shouldPersistImage(branch.image, defaults[id]?.image)) {
        delete cms.branches[id].image;
        changed = true;
      }
      if (cms.branches[id] && !Object.keys(cms.branches[id]).length) {
        delete cms.branches[id];
        changed = true;
      }
    }
    if (cms.branches && !Object.keys(cms.branches).length) {
      delete cms.branches;
      changed = true;
    }
  }

  if (Array.isArray(cms.branchList)) {
    if (cms.branchList.length === 0) {
      delete cms.branchList;
      changed = true;
    } else {
      cms.branchList = cms.branchList.map((branch) => {
        const next = { ...branch };
        const defaultImage = defaults[branch.id]?.image;
        if (next.image && !shouldPersistImage(next.image, defaultImage)) {
          delete next.image;
          changed = true;
        }
        return next;
      });
    }
  }

  if (cms.images) {
    for (const [key, value] of Object.entries({ ...cms.images })) {
      if (typeof value === "string" && isLegacyPicPath(value)) {
        delete cms.images[key];
        changed = true;
      }
    }
    if (!Object.keys(cms.images).length) {
      delete cms.images;
      changed = true;
    }
  }

  if (changed) saveCms(cms);
}

let cmsInitPromise = null;
let serverSyncTimer = null;

export function loadCms() {
  try {
    const raw = localStorage.getItem(CMS_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function saveCms(data, { syncToServer = false } = {}) {
  localStorage.setItem(CMS_KEY, JSON.stringify(data));
  if (syncToServer || isAdminAuthed()) {
    scheduleServerSync(data);
  }
}

export function initCmsFromServer() {
  if (!cmsInitPromise) {
    cmsInitPromise = fetchRemoteCms()
      .then(async (remote) => {
        if (hasRemoteCmsContent(remote)) {
          localStorage.setItem(CMS_KEY, JSON.stringify(remote));
          return;
        }

        const local = loadCms();
        if (isAdminAuthed() && hasRemoteCmsContent(local)) {
          await pushRemoteCms(local).catch(() => {
            /* admin can retry via Save */
          });
        }
      })
      .catch(() => {
        /* local dev or API unavailable — keep localStorage/defaults */
      });
  }
  return cmsInitPromise;
}

function scheduleServerSync(data) {
  clearTimeout(serverSyncTimer);
  serverSyncTimer = setTimeout(() => {
    pushRemoteCms(data).catch(() => {
      /* network errors are surfaced by explicit save action */
    });
  }, 600);
}

export async function syncCmsToServer() {
  clearTimeout(serverSyncTimer);
  await pushRemoteCms(loadCms());
}

export function getCmsValue(key) {
  const data = loadCms();
  return data.text?.[key];
}

export function getCmsMenu() {
  const data = loadCms();
  return data.menu ?? null;
}

export function getDefaultBranchList() {
  return Object.entries(defaultBranches).map(([id, data]) => ({
    id,
    ...structuredClone(data),
  }));
}

export function getBranchList() {
  const cms = loadCms();
  if (Array.isArray(cms.branchList) && cms.branchList.length > 0) {
    return cms.branchList.map((branch) => ({ ...branch }));
  }

  return getDefaultBranchList().map((branch) => ({
    ...branch,
    ...(cms.branches?.[branch.id] ?? {}),
  }));
}

export function getCmsBranches() {
  const list = getBranchList();
  return Object.fromEntries(list.map((branch) => [branch.id, branch]));
}

export function getDefaultBranches() {
  return structuredClone(defaultBranches);
}

function materializeBranchList(cms) {
  if (!Array.isArray(cms.branchList)) {
    cms.branchList = getDefaultBranchList().map((branch) => ({
      ...branch,
      ...(cms.branches?.[branch.id] ?? {}),
    }));
  }
  return cms.branchList;
}

export function addBranch() {
  const cms = loadCms();
  const list = materializeBranchList(cms);
  const id = `branch-${Date.now()}`;

  list.push({ id, ...createEmptyBranch() });
  cms.branchList = list;
  saveCms(cms);
  return id;
}

export function removeBranch(branchId) {
  const cms = loadCms();
  const list = materializeBranchList(cms);
  if (list.length <= 1) return false;

  const next = list.filter((branch) => branch.id !== branchId);
  if (next.length === list.length) return false;

  cms.branchList = next;
  if (cms.branches?.[branchId]) {
    delete cms.branches[branchId];
    if (!Object.keys(cms.branches).length) delete cms.branches;
  }

  saveCms(cms);
  return true;
}

export function getDefaultMenu() {
  return structuredClone(menuSections);
}

export function isAdminAuthed() {
  return sessionStorage.getItem(AUTH_KEY) === "1";
}

export async function refreshAdminSession() {
  try {
    const session = await readSession();
    if (session.authenticated) sessionStorage.setItem(AUTH_KEY, "1");
    else sessionStorage.removeItem(AUTH_KEY);
    return session.authenticated === true;
  } catch { sessionStorage.removeItem(AUTH_KEY); return false; }
}
export async function loginAdmin(user, pass) {
  await authenticate(user, pass);
  sessionStorage.setItem(AUTH_KEY, "1");
  return true;
}
export async function logoutAdmin() {
  await endSession();
  clearTimeout(serverSyncTimer);
  sessionStorage.removeItem(AUTH_KEY);
}

export function addMenuItem(sectionId) {
  const cms = loadCms();
  const menu = cms.menu ?? getDefaultMenu();
  const section = menu.find((s) => s.id === sectionId);
  if (!section) return false;

  section.items.push(createEmptyMenuItem());
  cms.menu = menu;
  saveCms(cms);
  return true;
}

export function removeMenuItem(sectionId, itemIndex) {
  const cms = loadCms();
  const menu = cms.menu ?? getDefaultMenu();
  const section = menu.find((s) => s.id === sectionId);
  if (!section) return false;
  if (section.items.length <= 1) return false;
  if (itemIndex < 0 || itemIndex >= section.items.length) return false;

  section.items.splice(itemIndex, 1);
  cms.menu = menu;
  saveCms(cms);
  return true;
}

export function addMenuSection() {
  const cms = loadCms();
  const menu = cms.menu ?? getDefaultMenu();
  const id = `category-${Date.now()}`;

  menu.push({
    id,
    title: "קטגוריה חדשה",
    items: [createEmptyMenuItem()],
  });

  cms.menu = menu;
  saveCms(cms);
  return id;
}

export function removeMenuSection(sectionId) {
  const cms = loadCms();
  const menu = cms.menu ?? getDefaultMenu();
  if (menu.length <= 1) return false;

  const next = menu.filter((section) => section.id !== sectionId);
  if (next.length === menu.length) return false;

  cms.menu = next;
  saveCms(cms);
  return true;
}

function materializeGallery(cms) {
  if (!Array.isArray(cms.gallery)) {
    cms.gallery = defaultGallery.map((item, index) => {
      const override = cms.images?.[`images.gallery.${index + 1}`];
      return override ? { ...item, src: override } : { ...item };
    });
  }
  return cms.gallery;
}

export function getGalleryList() {
  const cms = loadCms();
  return materializeGallery(cms).map((item) => ({ ...item }));
}

export function addGalleryItem() {
  const cms = loadCms();
  const list = materializeGallery(cms);
  list.push(createEmptyGalleryItem());
  cms.gallery = list;
  saveCms(cms);
}

export function removeGalleryItem(index) {
  const cms = loadCms();
  const list = materializeGallery(cms);
  if (list.length <= 1 || index < 0 || index >= list.length) return false;
  list.splice(index, 1);
  cms.gallery = list;
  saveCms(cms);
  return true;
}

export function persistGalleryField(index, fieldName, value) {
  const cms = loadCms();
  const list = materializeGallery(cms);
  if (!list[index]) return;
  list[index] = { ...list[index], [fieldName]: value };
  cms.gallery = list;
  saveCms(cms);
}

export function getGalleryFieldValue(index, fieldName) {
  return getGalleryList()[index]?.[fieldName] ?? "";
}

function materializeHeroSlides(cms) {
  if (!Array.isArray(cms.heroSlides)) {
    cms.heroSlides = defaultHeroSlides.map((slide, index) => {
      const override = cms.images?.[`images.hero.${index + 1}`];
      return override ? { ...slide, src: override } : { ...slide };
    });
  }
  return cms.heroSlides;
}

export function getHeroSlides() {
  const cms = loadCms();
  return materializeHeroSlides(cms).map((slide) => ({ ...slide }));
}

export function addHeroSlide() {
  const cms = loadCms();
  const list = materializeHeroSlides(cms);
  list.push(createEmptyHeroSlide());
  cms.heroSlides = list;
  saveCms(cms);
}

export function removeHeroSlide(index) {
  const cms = loadCms();
  const list = materializeHeroSlides(cms);
  if (list.length <= 1 || index < 0 || index >= list.length) return false;
  list.splice(index, 1);
  cms.heroSlides = list;
  saveCms(cms);
  return true;
}

export function persistHeroField(index, fieldName, value) {
  const cms = loadCms();
  const list = materializeHeroSlides(cms);
  if (!list[index]) return;
  list[index] = { ...list[index], [fieldName]: value };
  cms.heroSlides = list;
  saveCms(cms);
}

export function getHeroFieldValue(index, fieldName) {
  return getHeroSlides()[index]?.[fieldName] ?? "";
}

function materializeStoryParagraphs(cms) {
  if (!Array.isArray(cms.storyParagraphs)) {
    cms.storyParagraphs = defaultStoryParagraphs.map((text, index) => {
      const override = cms.text?.[`home.story.p${index + 1}`];
      return override ?? text;
    });
  }
  return cms.storyParagraphs;
}

export function getStoryParagraphs() {
  const cms = loadCms();
  return [...materializeStoryParagraphs(cms)];
}

export function addStoryParagraph() {
  const cms = loadCms();
  const list = materializeStoryParagraphs(cms);
  list.push(createEmptyStoryParagraph());
  cms.storyParagraphs = list;
  saveCms(cms);
}

export function removeStoryParagraph(index) {
  const cms = loadCms();
  const list = materializeStoryParagraphs(cms);
  if (list.length <= 1 || index < 0 || index >= list.length) return false;
  list.splice(index, 1);
  cms.storyParagraphs = list;
  saveCms(cms);
  return true;
}

export function persistStoryParagraph(index, value) {
  const cms = loadCms();
  const list = materializeStoryParagraphs(cms);
  if (!list[index]) return;
  list[index] = value;
  cms.storyParagraphs = list;
  saveCms(cms);
}

export function getStoryParagraphValue(index) {
  return getStoryParagraphs()[index] ?? "";
}

export function persistMenuField({ sectionId, itemIndex, fieldName, value, isSectionTitle }) {
  const cms = loadCms();
  const menu = cms.menu ?? getDefaultMenu();
  const section = menu.find((s) => s.id === sectionId);
  if (!section) return;

  if (isSectionTitle) {
    section.title = value;
  } else if (itemIndex >= 0 && section.items[itemIndex]) {
    if (value) section.items[itemIndex][fieldName] = value;
    else delete section.items[itemIndex][fieldName];
  }

  cms.menu = menu;
  saveCms(cms);
}

export function getMenuFieldValue({ sectionId, itemIndex, fieldName, isSectionTitle }) {
  const cms = loadCms();
  const menu = cms.menu ?? getDefaultMenu();
  const section = menu.find((s) => s.id === sectionId);
  if (!section) return "";

  if (isSectionTitle) return section.title;
  return section.items[itemIndex]?.[fieldName] ?? "";
}
